import React from 'react'
import DOMPurify from 'dompurify'
import { Col } from 'antd'
import dayjs from 'dayjs'
import Loading from '../../Utils/Loading'
import { TermInfoRow, TermsGeneralSettingsRow } from './styles'

interface GeneralTermsProps {
  isLoading: boolean
  latestData: {
    first_name: string
    last_name: string
    inserted_at: string
    term: {
      terms_and_conditions: string
      updated_at: string
    }
  }
}

const GeneralTerms = ({ latestData, isLoading }: GeneralTermsProps) => {
  const term = latestData?.term?.terms_and_conditions
  const termDate = latestData?.term?.updated_at

  return (
    <>
      {(!isLoading && term && (
        <>
          <TermInfoRow
            className='_mb-48'
            align='middle'
            justify='space-between'
          >
            <Col>
              <span className='_uppercase'>Signed by:</span>{' '}
              <span id='signee'>
                {latestData?.first_name} {latestData?.last_name}
              </span>{' '}
              on{' '}
              <strong>
                {dayjs(latestData?.inserted_at).format('D MMM YYYY')}
              </strong>
            </Col>
            <Col>
              <span className='_uppercase'>Last updated:</span>{' '}
              <strong className='_ml-12'>
                {dayjs(termDate).format('D MMM YYYY')}
              </strong>
            </Col>
          </TermInfoRow>
          <TermsGeneralSettingsRow justify='center'>
            <Col span={12}>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(term, {
                    USE_PROFILES: { html: true },
                    ADD_ATTR: ['target']
                  })
                }}
              />
            </Col>
          </TermsGeneralSettingsRow>
        </>
      )) || <Loading />}
    </>
  )
}

export default GeneralTerms
